import React from 'react';
import { Segment, Header, Tab } from 'semantic-ui-react';
import axios from 'axios';
import CreateCandidates from '../CreateCandidates/CreateCandidates';
import CreateCandidatesFromUNSA from '../CreateCandidates/CreateCandidatesFromUNSA';
import CandidatesPreview from '../CandidatesTab/CandidatesPreview';
import ConnectedCandidatesPreview from '../CandidatesTab/ConnectedCandidatesPreview';
import PreviousCandidatesPreview from '../CandidatesTab/PreviousCandidatesPreview';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class CreateCandidatesTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            candidates: [],
            showCreateCandidate: false,
        };
    }


    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');
    }


    render() {
        const panes = [
            {
                menuItem: 'UNSA',
                render: () => <Tab.Pane ><CreateCandidatesFromUNSA /></Tab.Pane>,
            }, {
                menuItem: 'Izvan UNSA',
                render: () => <Tab.Pane ><CreateCandidates /></Tab.Pane>,
            }
        ];
        return (
            <div>

                <h1> Kandidati  </h1>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Kreiranje kandidata
                        </Header>
                    </Segment>

                    <Segment>

                        <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} defaultActiveIndex={0} />


                    </Segment>


                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CreateCandidates/CreateCandidatesTab.js